import { UserRepository } from '@/interfaces/repositories/users';
import { useApolloClient } from '@/plugins/apollo/apollo';

import { GraphQLUserRepository } from './users';

let userRepository: UserRepository | null = null;

export function useUserRepository(options?: {
  repositoryInstance?: UserRepository;
}): UserRepository {
  if (options?.repositoryInstance) {
    userRepository = options.repositoryInstance;
    return options.repositoryInstance;
  }

  if (!userRepository) {
    userRepository = new GraphQLUserRepository(useApolloClient());
  }
  return userRepository;
}
